<script>
export default {
  name: 'CandidateListSkeleton',
  data: () => {
    return {
      numLoaders: 5,
    }
  },
}
</script>

<template>
  <article>
    <div>
      <v-row>
        <v-col sm="4" md="4" class="mr-4 mb-2">
          <v-text-field
            disabled
            :label="`${$t('candidateList.candidateListSearchPlaceHolder')}`"
          >
          </v-text-field>
        </v-col>

        <v-col sm="3" md="3"> </v-col>
      </v-row>

      <v-row>
        <v-col
          v-for="(loader, index) in numLoaders"
          :key="`candidate_skeleton_loader_${index}`"
          cols="12"
          md="4"
        >
          <v-skeleton-loader
            loading
            type="list-item-avatar-three-line"
            class="zoom-skeleton-title custom-elevation"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>
  </article>
</template>

<style lang="scss" scoped>
@import '@styles';

::v-deep.zoom-skeleton-title.v-skeleton-loader--is-loading {
  border-radius: 24px;
  .v-skeleton-loader__avatar {
    width: 100px; // change width or height here
    height: 100px;
    border-radius: 8px;
  }
  .v-skeleton-loader__text {
    height: 1rem;
  }
  .v-skeleton-loader__list-item-three-line,
  .v-skeleton-loader__list-item-avatar-three-line {
    height: 100%;
    padding: 20px 20px;
  }
}
</style>
